import testIds from '../config/testIds.json';
import { transformStringMapValuesToPaths } from './transformStringMapValuesToPaths';

type DeepReadonlyStringObject<T> = T extends string
  ? string
  : { readonly [K in keyof T]: DeepReadonlyStringObject<T[K]> };

export type TestIdConfig = typeof testIds;

export const $tid = transformStringMapValuesToPaths(testIds);

declare global {
  const $tid: DeepReadonlyStringObject<TestIdConfig>;

  interface Window {
    $tid: TestIdConfig;
  }
}
